'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFooter = exports.Footer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _recompose = require('recompose');

var _FooterStyle = require('./Footer.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withExpansion = (0, _recompose.withState)('isExpanded', 'handleExpansion', false);

var Footer = exports.Footer = function Footer(_ref) {
  var className = _ref.className,
      isExpanded = _ref.isExpanded,
      handleExpansion = _ref.handleExpansion;
  return _react2.default.createElement(
    'footer',
    { className: className + ' keepItTight' },
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'a',
        { onClick: function onClick() {
            return handleExpansion(!isExpanded);
          } },
        'Keep it tight: All content on this website is strictly confidential \xA0',
        _react2.default.createElement('i', { className: 'fa ' + (isExpanded ? 'fa-chevron-up' : 'fa-chevron-down') })
      )
    ),
    isExpanded && _react2.default.createElement(
      'div',
      { className: 'unAbridgedWarning' },
      _react2.default.createElement(
        'p',
        null,
        'All content on this website is stricly confidential and protected by law. Under no circumstances should this content be copied, captured, or shared with anyone outside Nike. Do not share with ETWs, vendors, independent contractors, or retailers. This is proprietary imagery and dialog intended for internal research and insight purposes only. If these terms are violated, severe action will be taken, up to termination of employment and any additional legal action necessary. This requirement ensures the protection of the athletes and Nike as limited by our contractual obligations and relationships.'
      )
    )
  );
};

Footer.propTypes = {
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className, but it will be merged with the glamorous className if you do.
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Determines whether to show the unabreviated keep it tight message.  Don't forget to keep it tight.
   */
  isExpanded: _propTypes2.default.bool,
  /**
   * setter for isExpanded
   */
  handleExpansion: _propTypes2.default.func
};

var StyledFooter = exports.StyledFooter = (0, _glamorous2.default)(Footer)(_FooterStyle.defaultStyle, _FooterStyle.mapPropsAndThemeToStyle);
exports.default = withExpansion(StyledFooter);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Footer/Footer.js
// module id = 416
// module chunks = 0